module.exports = __webpack_public_path__ + "media/feature-icons/Electronic_Signature-0d5a008a.svg";